<template>
  <div class="page">
    <div class="plate-one">
      <div class="plate-one-logo">
        <img src="@/assets/logo.png" alt="">
      </div>
      <div class="plate-one-pv">
        <van-icon name="friends-o"></van-icon><span>{{pv}}</span>
      </div>
    </div>
    <div class="plate-two">
      <img src="@/assets/video1.png" alt="">
      <router-link class="plate-two-play" to="/live"></router-link>
    </div>
    <div ref="box" class="plate-three">
      <div class="plate-three-img plate-three-img_one">
        <img src="@/assets/p1.png" alt="">
      </div>
      <div class="plate-three-img plate-three-img_two">
        <img src="@/assets/p2.png" alt="">
      </div>
      <div class="plate-three-btn plate-three-btn_one" @click="goPage(1)">
        <img src="@/assets/btn1.png" alt="">
      </div>
      <div class="plate-three-btn plate-three-btn_two" @click="goPage(2)">
        <img src="@/assets/btn2.png" alt="">
      </div>
      <div class="plate-three-btn plate-three-btn_three" @click="goPage(3)">
        <img src="@/assets/btn3.png" alt="">
      </div>
      <div class="plate-three-btn plate-three-btn_four" @click="goPage(4)">
        <img src="@/assets/btn4.png" alt="">
      </div>
      <div class="plate-three-btn plate-three-btn_five" @click="goPage(5)">
        <img src="@/assets/btn5.png" alt="">
      </div>
      <div class="plate-three-btn plate-three-btn_six" @click="goPage(6)">
        <img src="@/assets/btn6.png" alt="">
      </div>
    </div>
   <!--  <div class="plate-three">
      <div class="plate-three-img plate-three-img_one">
        <img src="@/assets/p1.png" alt="">
      </div>
      <div class="plate-three-img plate-three-img_two">
        <img src="@/assets/p2.png" alt="">
      </div>
      <bubble></bubble>
    </div> -->
  </div>
</template>

<script>
import { addPv, getPv } from '@/api/api'
export default {
  data() {
    return {
      liveInfo: {},
      pv: 0
    }
  },
  async created() {
    this.$wxShare(
      '2022年徐汇区“全国科普日”活动',
      '“新徐汇 新科普”云上嘉年华',
      'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_2a12fa0ad8df461b887daafe09631388.png'
    )
    await addPv({
      headimgurl: '吴彦祖',
      nickName: '吴彦祖',
      realName: '吴彦祖'
    }, 1430)
    this.getPv()
    setTimeout(() => {
      this.getPv()
    }, 3000)
  },
  mounted() {
  },
  methods: {
    goPage(type) {
      this.$router.push({
        path: `/page?type=${type}`
      })
    },
    // 获取pv
    getPv() {
      getPv('', 1430).then(res => {
        var data = res.data
        this.pv = data.pv
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  $all-width: 94%;
  .page {
    width: 100%;
    height: 100%;
    background: url(~@/assets/bg.jpg) no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    img {
      width: 100%;
    }
  }
  .plate-one {
    display: flex;
    padding-top: .15rem;
    justify-content: space-between;
    width: $all-width;
    margin: 0 auto;
    height: .3rem;
    &-logo {
      height: 100%;
      img {
        width: auto;
        height: 100%;
      }
    }
    &-pv {
      // background-color: rgba($color: #000000, $alpha: .3);
      font-size: .18rem;
      color: #fff;
      line-height: .3rem;
      border-radius: .15rem;
    }
  }
  .plate-two {
    width: 85%;
    margin: 0 auto;
    padding-top: .25rem;
    position: relative;
    &-play {
      display: block;
      width: 30%;
      height: .5rem;
      position: absolute;
      top: 1.74rem;
      left: 1.08rem;
    }
  }
  .plate-three {
    flex-shrink: 1;
    flex-grow: 1;
    width: 95%;
    margin: auto;
    position: relative;
    &-img {
      position: absolute;
       &_one {
        width: 1.2rem;
        top: 2%;
      }
      &_two {
        width: 1.2rem;
        right: 0;
        top: 60%;
      }
    }
    &-btn {
      position: absolute;
      width: .7rem;
      animation-name: btn;
      animation-duration: .8s;
      animation-direction: alternate;
      animation-iteration-count: infinite;
      &_one {
        left: 30%;
        top: 5%;
        animation-delay: .3s;
      }
      &_two {
        left: 58%;
        top: 8%;
        animation-delay: .2s;
      }
      &_three {
        left: 14%;
        top: 38%;
        animation-delay: .5s;
      }
      &_four {
        left: 42%;
        top: 34%;
        animation-delay: .1s;
      }
      &_five {
        left: 72%;
        top: 33%;
        animation-delay: .6s;
      }
      &_six {
        left: 30%;
        top: 60%;
        animation-delay: .5s;
      }
    }
    @keyframes btn {
    0% {
      opacity: 1;
      transform: scale(1);
    }
    100% {
      opacity: .8;
      transform: scale(.9);
    }
  }
  }
</style>
